import { List } from "immutable";
import { amphibiousGetIn } from "helpers/objUtils";

export const sortItems = (
    items: List<any>,
    sortKey: string[],
    sortDirection: "asc" | "desc" = "desc",
    sortType: "string" | "number" = "string"
) => {
    if (!sortKey) {
        return items;
    }

    const aLessThanB = sortDirection === "asc" ? -1 : 1;
    const aGreaterThanB = aLessThanB * -1;

    return items.sortBy(
        (data) => {
            const value = amphibiousGetIn(data, sortKey);
            if (sortType === "number") {
                return parseFloat(value);
            }
            return value;
        },
        (a, b) => {
            if (a < b) {
                return aLessThanB;
            }
            if (a > b) {
                return aGreaterThanB;
            }
            if (a === b) {
                return 0;
            }
        }
    ) as List<any>;
};
